import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to={defaultHomeFor(user.role)} replace />;
  }
  return children;
}

export function defaultHomeFor(role) {
  switch (role) {
    case "SUPER_ADMIN": return "/admin";
    case "ADMIN_SUCURSAL": return "/dashboard";
    case "MESERO": return "/mesero";
    case "COCINA": return "/mis-areas";
    case "BEBIDAS": return "/mis-areas";
    case "FREIDORA": return "/mis-areas";
    case "CAJA": return "/caja";
    case "REPARTIDOR": return "/reparto";
    default: return "/login";
  }
}
